import {h} from 'hastscript'

import {HastElementWidget} from './hast-element'

/** Renders an empty `span` element. `EmptySpanWidget` is a singleton and cannot be constructed. */
export const EmptySpanWidget = new HastElementWidget(h('span'))
